import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

type StyleProps = {
  isExpiredOrInvalidOrRejected: boolean;
};

const styles = makeStyles((theme: Theme) => ({
  container: {
    width: "100%",
    height: "100vh",
    background: "linear-gradient(90deg, #F9FAFB 0%, #F2F4F7 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "7.5rem",
    "@media (max-width: 600px)": {
      padding: "2.5rem",
    },
  },

  containerGrid: {
    height: "100%",
    width: "100%",
    margin: "0 auto",
    background: "#FFF",
    boxShadow: "2px 1px 5px rgba(152, 162, 179, 0.15), 0px 4px 10px rgba(48, 140, 219, 0.05)",
    borderRadius: "0.75rem",
  },

  asideLeft: {
    width: "100%",
    height: "100%",
    borderRadius: "0.75rem 0px 0px 0.75rem",
    background: "#FAFCFE",
    margin: "0 auto",
  },

  sectionAsideLeft: {
    margin: "0 auto",
    overflow: "hidden",
    maxWidth: "inherit",
  },

  shipeeziLogo: {
    maxWidth: "200px",
    marginTop: "2.5rem",
    marginLeft: "3.25rem",
    height: "5vh",
  },

  containerRafiki: {
    whiteSpace: "nowrap",
  },

  sectionRafiki: {
    display: "inline-block",
    height: "37.2vh",
    width: "100%",
    marginTop: "10%",
  },

  rafiki: {
    width: "100%",
    height: "100%",
  },

  asideRight: {
    padding: "1rem",
    height: "100%",
  },

  containerAsideRight: {
    width: "60%",
    "@media (max-width: 1300px)": {
      width: "65%",
    },
    "@media (max-width: 1100px)": {
      width: "70%",
    },
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },

  sectionInvitation: {
    width: "100%",
    height: "100%",
  },

  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    color: (props: StyleProps) => {
      return props.isExpiredOrInvalidOrRejected ? "#F04438" : "#465869";
    },
    fontSize: "1.5rem",
    marginBottom: "0px",
  },

  invitationDescription: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: (props: StyleProps) => {
      return props.isExpiredOrInvalidOrRejected ? "1rem" : "0.875rem";
    },
    color: "#465869",
    "& > span": {
      fontWeight: 700,
    },
  },

  invitationDescriptionDeclined: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#465869",
    marginTop: "1rem !important",
    "& > a": {
      textDecoration: "underline",
    },
  },

  invitationDescriptionExpired: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#465869",
    "& > a": {
      textDecoration: "underline",
    },
  },

  actionButton: {
    marginTop: "1.5rem !important",
    padding: "0.625rem 1.25rem",
  },

  loadingRequestNewInviteModal: {
    width: "16vw",
    [theme.breakpoints.down("md")]: {
      width: "30vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "50vw",
    },
    [theme.breakpoints.down("xs")]: {
      width: "70vw",
    },

    "& div > div:nth-child(1)": {
      display: "none",
    },

    "& div > div:nth-child(2)": {
      margin: 0,
      padding: "2.5rem",
    },
  },

  loadingRequestNewInviteModalContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    flexDirection: "column",
    gap: "2.25rem",

    "& h1": {
      color: "#308CDB !important",
      fontSize: "1.25rem",
      whiteSpace: "nowrap",
    },
  },

  loadingScreen: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
    justifyContent: "center",
    height: "80%",
    alignItems: "center",
  },

  loadingScreenLabel: {
    fontFamily: "Manrope",
    fontSize: "1rem",
    color: "#9CA6AF",
  },
}));

export default styles;
